import { getCookie } from '@/utils/cookies';
import { getOS, platWindow, platDocument } from '@/utils/env';
import config from '@/config';

export function getHttpHeader() {
  return Promise.resolve({
    device: getOS(platWindow.navigator.userAgent),
    openid: getCookie('openId') || getCookie('openid') || '',
    acct_type: getCookie('loginType') || getCookie('acctype') || '',
    appid: getCookie('appId') || getCookie('appid') || '',
    uuid: getCookie('uuid') || '',
    access_token: getCookie('accessToken') || getCookie('access_token') || '',
    commReq: '', // todo 参数确认
    userAgent: platWindow.navigator.userAgent,
    'User-Agent': platWindow.navigator.userAgent,
    cookie: platDocument.cookie,
  });
}

/**
 * 判断方法是否支持同步调用
 * @return {Boolean}
 */

export function checkSupportFnSync({ fn }) {
  if (fn === 'getSwitchStatusSync') {
    return true;
  }
  return false;
}

/**
 * 从UA判断iOS审核开关是否开启
 * @return {Q.Promise<boolean>}
 */
export function getSwitchStatus() {
  return Promise.resolve(false);
}

/**
 * 从UA判断iOS审核开关是否开启（同步版本）
 * @return {Boolean}
 */
export function getSwitchStatusSync() {
  return false;
}

/**
 * 获取当前网络环境 0:正式环境;2: 测试环境; 3:开发环境
 * @return {*}
 */
export function getNetEnvironment() {
  if (platWindow.location && platWindow.location.href && platWindow.location.href.indexOf('env=prod') !== -1) {
    return Promise.resolve(config.netEnvironment.formal);
  }
  if (platWindow && platWindow.location && (platWindow.location.href.indexOf(config.web.testHost) === 0 || platWindow.location.hostname === 'localhost')) {
    return Promise.resolve(config.netEnvironment.test);
  }
  return Promise.resolve(config.netEnvironment.formal);
}

/**
 * 数据存储  --- web不支持
 * @param {Object}  params
 * @param {String} [params.key] 存储的键
 * @param {String} [params.value] 存储的值
 * @param {Number} [params.user_related] 是否用户相关，0不相关，1表示相关
 * @param {Number} [params.action] 操作行为，1为查询，2为删除，3为存储
 * @return {*}
 */
// eslint-disable-next-line no-unused-vars
export function curdData(params) {
  // todo
  return Promise.reject();
}

/**
 * 展示引导气泡（固定有按钮）  --- web不支持
 * @param {String} instanceId
 * @param {String} tips
 * @param {Number} direction 箭头方向 0-left,1-right,2-top,3-bottom, 8-top_left,9-top_right,10-bottom_left,11-bottom_right
 * @param {Number} posX
 * @param {Number} posY
 * @return {*}
 */
// eslint-disable-next-line no-unused-vars
export function showBubbleTips(instanceId, tips, direction, posX, posY) {
}

/**
 * 展示引导气泡（可隐藏按钮）  --- web不支持
 * @param {String} instanceId
 * @param {String} tips
 * @param {Number} direction 箭头方向  0-left,1-right,2-top,3-bottom, 8-top_left,9-top_right,10-bottom_left,11-bottom_right
 * @param {Number} posX
 * @param {Number} posY
 * @param {Object} param
 * @param {Boolean} param.showKnownBtn 是否展示"知道了"按钮
 * @return {*}
 */
// eslint-disable-next-line no-unused-vars
export function showBubbleTipsWithParam(instanceId, tips, direction, posX, posY, param) {
}

/**
 * 复制  --- web暂不支持
 * @param {String} content 复制的文本内容
 * */
// eslint-disable-next-line no-unused-vars
export function setClipData(content) {

}

/**
 * 展示toast --- web暂不支持
 * @param text
 * @return {*}
 */
// eslint-disable-next-line no-unused-vars
export function showToast(text) {
}
